// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"bc7a716f","513":"1b2af858","703":"b43aaf95"}[chunkId] + ".chunk.js";
};